
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"181","height":"78","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".16","d":"M285 15.133L143-93 1 15.133","stroke":"#000C1F"}}),_c('path',{attrs:{"opacity":".12","d":"M285 54.1L143-54.033 1 54.1","stroke":"#000C1F"}}),_c('path',{attrs:{"opacity":".1","d":"M285 93.066L143-15.066 1 93.066","stroke":"#000C1F"}}),_c('path',{attrs:{"opacity":".08","d":"M285 132.033L143 23.9 1 132.033","stroke":"#000C1F"}}),_c('path',{attrs:{"opacity":".05","d":"M285 171L143 62.867 1 171","stroke":"#000C1F"}})])
          )
        }
      }
    